export const isE2EModeEnabled = (): boolean => {
  return process.env.REACT_APP_E2E_MODE === 'true';
};

export const getE2EAccessToken = (): string => {
  return process.env.REACT_APP_E2E_ACCESS_TOKEN || 'e2e-access-token';
};